const _blankRoute = [
  {
    path: "/react",
    loader: () => import("src/view/ReactApp/ReactAppLink"),
  },
  {
    path: "/Login",
    loader: () => import("src/view/Login/Login"),
  },
  {
    path: "/AutoLogin",
    loader: () => import("src/view/Login/loginAD"),
  },
].filter(Boolean);

const _CommonRoute = [
  {
    path: "/",
    loader: () => import("src/view/Home/Homepage"),
    exact: true,
  },
  // {
  //   path: "/Login",
  //   loader: () => import("src/view/Login/Login"),
  //   // exact: true,
  // },
  {
    path: "/Home",
    loader: () => import("src/view/Home/Home"),
  },
  {
    path: "/ADLogin",
    loader: () => import("src/view/Login/TestADLogin"),
  },
  // {
  //   path: "/GroupCategory_List",
  //   loader: () => import("src/view/GroupCategory/GroupCategory_List"),
  // },
  // {
  //   path: "/GroupCategory_Edit",
  //   loader: () => import("src/view/GroupCategory/GroupCategory_Edit"),
  // }, 
  {
    path: "/LinkSetup",
    loader: () => import("src/view/LinkSetUp/LinkSetUp_List"),
  },
  {
    path: "/LinkSetUp_Edit",
    loader: () => import("src/view/LinkSetUp/LinkSetUp_Edit"),
  },  
  {
    path: "/Category",
    loader: () => import("src/view/Category/Category"),
  },
  {
    path: "/Category_Edit",
    loader: () => import("src/view/Category/Category_Edit"),
  },
  {
    path: "/ManageRole",
    loader: () => import("src/view/ManageRole/ManageRole_List"),
  }, 
  {
    path: "/ManageRole_Edit",
    loader: () => import("src/view/ManageRole/ManageRole_Edit"),
  },   
  {
    path: "/ManagePermission",
    loader: () => import("src/view/ManagePermission/ManagePermission_Set"),
  },      
  {
    path: "/Homepage",
    loader: () => import("src/view/Home/Homepage"),
  },
  {
    path: "/Report",
    loader: () => import("src/view/Report/Report"),
  },
  {
    path: "/Summary_Innovation_Idea",
    loader: () => import("src/view/Report/SummaryInnovationIdea/SummaryInnovation"),
  },
  {
    path: "/Summary_Visitor",
    loader: () => import("src/view/Report/SummaryVisitor/SummaryVisitor"),
  },
  {
    path: "/Dashboard",
    loader: () => import("src/view/Dashboard/Dashboard"),
  },
  {
    path: "/InnovationScoringSummary_List",
    loader: () => import("src/view/InnoScoring/InnoScoring_List"),
  },
  {
    path: "/InnovationScoringSummaryAddExcel_List",
    loader: () => import("src/view/InnoScoring/InnoScoringAddExel"),
  },
  {
    path: "/InnovationScoringSummary_Edit",
    loader: () => import("src/view/InnoScoring/InnoScoring_Edit"),
  },
  {
    path: "/Generate_List",
    loader: () => import("src/view/GenerateFile/Generate_List"),
  },
  {
    path: "/Generate_Edit",
    loader: () => import("src/view/GenerateFile/Generate_Edit"),
  },
  {
    path: "/ForbiddenWords_List",
    loader: () => import("src/view/ForbiddenWords/ForbiddenWords_list"),
  },
  {
    path: "/ForbiddenWords_Edit",
    loader: () => import("src/view/ForbiddenWords/ForbiddenWords_Edit"),
  },
  {
    path: "/ManageDivision_List",
    loader: () => import("src/view/ManageDivision/ManageDivision_List"),
  },
  {
    path: "/ManageDivision_Edit",
    loader: () => import("src/view/ManageDivision/ManageDivision_Edit"),
  },
  {
    path: "/Search",
    loader: () => import("src/view/Home/SearchPage"),
  },
  {
    path: "/InnoTeamManual_List",
    loader: () => import("src/view/Manual/InnoTeamManual_List"),
  },
  {
    path: "/UserManual_List",
    loader: () => import("src/view/Manual/UserManual_List"),
  },
  {
    path: "/Manual",
    loader: () => import("src/view/Manual/Manual"),
  },
  {
    path: "/ManageUser_Edit",
    loader: () => import("src/view/ManageUser/UserInfo_Edit"),
  },      
  {
    path: "/ManageUser",
    loader: () => import("src/view/ManageUser/UserInfo_List"),    
  },    
  {
    path: "/Banner",
    loader: () => import("src/view/Banner/Banner_List"),
  },
  {
    path: "/Banner_Edit",
    loader: () => import("src/view/Banner/Banner_Edit"),
  },
  {
    path: "/MasterDataList",
    loader: () => import("src/view/MasterDataList/MasterDataList"),
  },
  {
    path: "/StageSetup",
    loader: () => import("src/view/StageSetup/StageSetup_List"),
  },
  {
    path: "/State1",
    loader: () => import("src/view/StageSetup/State1/State1_List"),
  },
  {
    path: "/State1_Edit",
    loader: () => import("src/view/StageSetup/State1/State1_Edit"),
  },
  {
    path: "/State2",
    loader: () => import("src/view/StageSetup/State2/State2_List"),
  },
  {
    path: "/State2_Edit",
    loader: () => import("src/view/StageSetup/State2/State2_Edit"),
  },
  {
    path: "/State3",
    loader: () => import("src/view/StageSetup/State3/State3_List"),
  },
  {
    path: "/State3_Edit",
    loader: () => import("src/view/StageSetup/State3/State3_Edit"),
  },
  {
    path: "/State4",
    loader: () => import("src/view/StageSetup/State4/State4_List"),
  },
  {
    path: "/State4_Edit",
    loader: () => import("src/view/StageSetup/State4/State4_Edit"),
  },
  {
    path: "/State5",
    loader: () => import("src/view/StageSetup/State5/State5_List"),
  },
  {
    path: "/State5_Edit",
    loader: () => import("src/view/StageSetup/State5/State5_Edit"),
  },
  {
    path: "/State6",
    loader: () => import("src/view/StageSetup/State6/State6_List"),
  },
  {
    path: "/State6_Edit",
    loader: () => import("src/view/StageSetup/State6/State6_Edit"),
  },
  {
    path: "/IdeaType",
    loader: () => import("src/view/IdeaType/IdeaType_List"),
  },
  {
    path: "/IdeaType_Edit",
    loader: () => import("src/view/IdeaType/IdeaType_Edit"),
  },
  {
    path: "/CommentOne",
    loader: () => import("src/view/SendComment/CommentOne"),
  },
  {
    path: "/InnovationClinic",
    loader: () => import("src/view/InnovationClinic/InnovationClinic"),
  },
  {
    path: "/InnovationClinic_List",
    loader: () => import("src/view/InnovationClinic/InnovationClinic_List"),
  }, 
  {
    path: "/InnovationClinic_Create",
    loader: () => import("src/view/InnovationClinic/InnovationClinic_Create"),
  },
  {
    path: "/InnovationClinic_Detail",
    loader: () => import("src/view/InnovationClinic/InnovationClinic_Detail"),
  }, 
  {
    path: "/News_List",
    loader: () => import("src/view/News/News_List"),
  }, 
  {
    path: "/MyNews_List",
    loader: () => import("src/view/News/News_MyNews_List"),
  }, 
  {
    path: "/News_Create",
    loader: () => import("src/view/News/News_Create"),
  },
  {
    path: "/News_Detail",
    loader: () => import("src/view/News/News_Detail"),
  }, 
  {
    path: "/SettingScore",
    loader: () => import("src/view/SettingScore/SettingScore_List"),
  },  
  {
    path: "/CreateIdea",
    loader: () => import("src/view/CreateIdea/Stage1-3/CreateIdea_Timeline"),
  }, 
  {
    path: "/TN",
    loader: () => import("src/view/CreateIdea/Stage1-3/TN_ReviewSubmit"),
  }, 
  {
    path: "/ScorerCommitee",
    loader: () => import("src/view/CreateIdea/Stage1-3/ScorerCommitee"),
  },
  {
    path: "/CreateIdea_File",
    loader: () => import("src/view/CreateIdea/Stage4-6/CreateIdea_File"),
  }, 
  {
    path: "/TN_File",
    loader: () => import("src/view/CreateIdea/Stage4-6/TN_File"),
  }, 
  {
    path: "/ScorerCommitee_File",
    loader: () => import("src/view/CreateIdea/Stage4-6/ScorerCommitee_File"),
  },
  {
    path: "/NewsApprove",
    loader: () => import("src/view/News/NewsApprove/NewsApprove_List"),
  },
  {
    path: "/NewsApprove_Edit",
    loader: () => import("src/view/News/NewsApprove/NewsApprove_Detail"),
  },
  {
    path: "/InnovationIdea",
    loader: () => import("src/view/InnovatinIdea/InnovationIdea_List"),
  },  
  {
    path: "/InnovationIdea_Detail",
    loader: () => import("src/view/InnovatinIdea/InnovationIdea_Detail"),
  },  
  {
    path: "/Eventlog_Website",
    loader: () => import("src/view/Eventlog/Evenlog_Website"),
  },
  {
    path: "/Eventlog_Innovation",
    loader: () => import("src/view/Eventlog/Eventlog_Innovation"),
  },
  {
    path: "/Eventlog",
    loader: () => import("src/view/Eventlog/Event"),
  },
  {
    path: "/ManageMenu",
    loader: () => import("src/view/ManageMenu/ManageMenu"),
  }, 
  {
    path: "/CenterLink",
    loader: () => import("src/view/CenterLink/CenterLinkPage"),
  },
  {
    path: "/CheckMail",
    loader: () => import("src/view/Checkmail/CheckMail"),
  },
  {
    path: "/TestMail",
    loader: () => import("src/view/TestSendMail/TestMail"),
  },
  
  
].filter(Boolean);

export default { _blankRoute, _CommonRoute };
